define(["backbone", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  Properties,
  Messenger,
) {
  "use strict";

  const ResponseTransformationOperationsModel = {};

  ResponseTransformationOperationsModel.responseTransformationOperation = Backbone.Model.extend({
    defaults: {
      name: "",
      displayName: "",
    },
  });

  ResponseTransformationOperationsModel.responseTransformationOperations =
    Backbone.Collection.extend({
      model: ResponseTransformationOperationsModel.responseTransformationOperation,

      url: function () {
        const kbId = Messenger.reqres.request("active:kb");
        return `${Properties.rootURL}/${kbId}/intents/transformTextOperations`;
      },
    });

  return ResponseTransformationOperationsModel;
});
